export { ReactComponent as AIIllustration } from './AI.svg';
export { ReactComponent as AddAccountIcon } from './AddAccount.svg';
export { ReactComponent as ArnoldLoading } from './ArnoldLoading.svg';
export { ReactComponent as ColorfulEnvelopeIcon } from './ColorfulEnvelope.svg';
export { ReactComponent as LockIcon } from './Lock.svg';
export { ReactComponent as OpenEndedIconBig } from './OpenEndedIconBig.svg';
export { ReactComponent as OptionsIconBig } from './OptionsIconBig.svg';
export { ReactComponent as TellIconBig } from './TellIconBig.svg';
export { ReactComponent as ErrorIllustration } from './ErrorIllustration.svg';
export { ReactComponent as QuestionIcon } from './QuestionIcon.svg';
export { ReactComponent as ScaleIcon } from './ScaleIcon.svg';
